<form #createStoryboardForm="ngForm" (ngSubmit)="create()">
  <div class="modal-header justify-content-end">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body has-warning">
    <h2 class="mb-4">New Storyboard</h2>
    <p class="create-storyboard-text mb-4">
      To Create a new Storyboard you need to upload a WAV or MP3 file. <br />
      We recommend that the file would be between 5 and 1200 seconds long.
    </p>
    <div class="mb-4 px-5">
      <input type="text" [(ngModel)]="storyboard.title" #input name="title" id="title" #title="ngModel" class="form-control storyboard-title" [ngClass]="{'form-control-warning': !title.valid && title.dirty}" placeholder="Type storyboard name here" required/>
    </div>
    <div class="mb-2">
      <b>Aspect Ratio</b>
    </div>
    <div>
      <select name="aspectRatios" [(ngModel)]="storyboard.aspect_ratio" class="form-control aspect-ratio">
        <option value="16:9">16:9</option>
        <option value="16:10">16:10</option>
        <option value="1:1">1:1</option>
        <option value="21:9">21:9</option>
        <option value="4:3">4:3</option>
        <option value="9:16">9:16</option>
      </select>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="submit" class="btn btn-primary create-storyboard-btn" [disabled]="!createStoryboardForm.form.valid"><i class="fa fa-plus"></i> {{ 'CREATE' | translate }}</button>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/create-storyboard/create-storyboard.component.html